export default __webpack_public_path__ + "static/media/walkthrough-01.d953598c.svg";